import { render, staticRenderFns } from "./EditPresetModal.vue?vue&type=template&id=981ae960&scoped=true"
import script from "./EditPresetModal.vue?vue&type=script&lang=js"
export * from "./EditPresetModal.vue?vue&type=script&lang=js"
import style0 from "./EditPresetModal.vue?vue&type=style&index=0&id=981ae960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ae960",
  null
  
)

export default component.exports